import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"download-btn"},[_c(VTooltip,{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c(VBtn,_vm._g({attrs:{"icon":"","color":"primary"},on:{"click":_vm.onClick}},on),[_c(VIcon,[_vm._v(" mdi-download ")])],1)]}}])},[_c('span',[_vm._v("Download")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }